import { imageField } from 'molecules/Image/config';
import { videoFields } from 'molecules/Video/config';

import type { Input } from '@builder.io/sdk';

export const lightboxHeroFields = [
  {
    name: 'heading',
    type: 'string',
  },
  {
    name: 'subhead',
    type: 'string',
  },
  {
    name: 'cta',
    type: 'object',
    subFields: [
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'link',
        type: 'string',
      },
    ],
  },
  ...videoFields,
  imageField('icon'),
  imageField('thumbnailImage'),
  {
    name: 'statHeading',
    type: 'string',
  },
  {
    name: 'stats',
    type: 'list',
    subFields: [
      {
        name: 'stat',
        type: 'string',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const lightboxHeroConfig = {
  name: 'Lightbox Hero',
  inputs: lightboxHeroFields,
};

export type LightboxHeroProps = GenerateBuilder<typeof lightboxHeroFields>;

export default lightboxHeroConfig;
